import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR CATEGORY STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH CATEGORY ******************
			case types.FETCH_CATEGORY_LOADING:
				draft.isLoaded = false;
				break;

			case types.FETCH_CATEGORY_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				break;

			case types.FETCH_CATEGORY_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				break;

			default:
				return state;
		}
	});
